// extracted by mini-css-extract-plugin
export default {"root":"IconTabNav_root__YgtSU","filled":"IconTabNav_filled__OIpXH"};